<template>
  <div>
    <div class="container">
      <!-- <el-form :inline="true" :model="query" ref="query">
        <el-form-item label="角色名称" prop="roleName">
          <el-input v-model="query.roleName" placeholder="角色名称"></el-input>
        </el-form-item>
        <el-button type="primary" icon="el-icon-search" @click="handleSearch"
          >查询</el-button
        >
        <el-button type="primary" icon="el-icon-delete" @click="handleClear"
          >重置</el-button
        >
      </el-form> -->
      <e-search
        :data="query"
        :field-list="roleManage.fieldList"
        :list-type-info="roleManage.listTypeInfo"
        @handleFilter="handleQuery"
        @handleReset="handleReset"
      ></e-search>
    </div>
    <div class="container">
      <!--            <div style="margin-bottom: 20px">-->
      <!--                    <el-button type="primary" @click="handleAddRole" >新增</el-button>-->
      <!--                    <el-button type="primary" @click="handleDeleteRole" >删除</el-button>-->
      <!--                    <el-button type="primary" @click="handleAssignAuth" >分配功能权限</el-button>-->
      <!--            </div>-->

      <!-- <TableList
        :loading="loading"
        :table-data="tableData"
        :table-label="tableLabel"
        :table-option="tableOption"
        @handleButton="handleButton"
        @handleSortChange="handleSortChange"
        @handleSelectionChange="handleSelectionChange"
        :row-key="rowKey"
      >
        <template v-slot:index="slot">
          {{ slot.scope.row.$index + 1 }}
        </template>
        <template #createByName>
          系统管理员
        </template>
      </TableList> -->

      <eTableList :table-data="tableData" :table-label="tableLabel">
        <template #createByName>
          系统管理员
        </template>
        <template #optionsSlot="{scope}">
          <!-- 使用UI组件带下划线文字按钮 -->
          <eui-btn @click="handleCheck(scope)" type="link" size="12"
            >查看</eui-btn
          >
        </template>
      </eTableList>
      <div class="pagination">
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :page-sizes="[10, 20, 30, 40, 50, 60, 80, 100]"
          layout="total, sizes, prev, pager, next, jumper"
          :current-page="productTagPage.currentPage"
          :page-size="productTagPage.pageSize"
          :total="productTagPage.pageTotal"
          prev-text="上一页"
          next-text="下一页"
        ></el-pagination>
      </div>
    </div>
    <AddRoleDialog
      :visible="addRoleDialogShow"
      :role-data="roleData"
      :dialog-title="dialogTitle"
      @close="closeAddRole"
    ></AddRoleDialog>
    <CheckRoleDialog
      :role-data="roleData"
      :visible="checkRoleDialogShow"
      @close="closeCheckRole"
      v-if="checkRoleDialogShow"
    ></CheckRoleDialog>
  </div>
</template>

<script>
import AddRoleDialog from "../../components/authority/addRoleDialog";
import CheckRoleDialog from "../../components/authority/checkRoleDialog";
import Api from "../../api/authority/index";
import { roleManage } from "./componentsData";
import eSearch from "../../components/common/e-search";
import eTableList from "@/modules/projectA/components/common/e-table-list";

export default {
  name: "roleManage",
  components: {
    AddRoleDialog,
    eTableList,
    CheckRoleDialog,
    eSearch,
  },
  props: {},
  data() {
    return {
      query: {
        roleName: "",
      },
      roleManage,
      loading: false,
      tableData: [],
      tableLabel: [
        { label: "角色名称", param: "roleName", align: "center" },
        { label: "角色描述", param: "remark", align: "center" },
        {
          label: "创建人",
          param: "createByName",
          align: "center",
          slot: "createByName",
        },
        { label: "创建时间", param: "createTime", align: "center" },
        {
          label: "操作",
          param: "options",
          align: "center",
          slot: "optionsSlot",
        },
      ],
      productTagPage: {
        currentPage: 1,
        pageSize: 10,
        pageTotal: 0,
      },
      tableOption: {
        label: "操作",
        width: "200",
        fixed: "right",
        permission: "0",
        options: [
          // { label: '编辑', type: 'primary', methods: 'handleEdit' },
          {
            label: "查看",
            type: "text",
            methods: "handleCheck",
            permission: "/ubm/role/queryRoleAuthority",
          },
          // { label: '复制角色', methods: 'handleCopy' },
        ],
      },
      addRoleDialogShow: false,
      roleData: {},
      dialogTitle: "",
      checkRoleDialogShow: false,
      selectRows: [],
      rowKey: "roleId",
    };
  },
  computed: {},
  created() {
    this.getRoleList();
  },
  methods: {
    handleQuery(val) {
      this.query = val;
      this.productTagPage.currentPage = 1;
      this.productTagPage.pageSize = 10;
      this.productTagPage.pageTotal = 0;
      this.getRoleList();
    },
    handleReset() {
      this.query.roleName = "";
      this.productTagPage.currentPage = 1;
      this.productTagPage.pageSize = 10;
      this.productTagPage.pageTotal = 0;
      this.getRoleList();
    },
    handleButton(val) {
      if (val.methods === "handleEdit") {
        this.handleEdit(val);
      }
      if (val.methods === "handleCheck") {
        this.handleCheck(val);
      }
      if (val.methods === "handleCopy") {
        this.handleCopy(val);
      }
    },
    handleSortChange() {},
    handleSelectionChange(val) {
      this.selectRows = Object.assign([], val);
    },
    handleSizeChange(val) {
      this.productTagPage.pageSize = val;
      this.getRoleList();
    },
    handleCurrentChange(val) {
      this.productTagPage.currentPage = val;
      this.getRoleList();
    },
    handleEdit(val) {
      this.addRoleDialogShow = true;
      this.dialogTitle = "编辑角色";
      this.roleData = val.row;
    },
    handleCheck(val) {
      this.checkRoleDialogShow = true;
      this.roleData = val.row;
    },
    handleCopy(val) {
      let params = {
        roleName: val.row.roleName,
        remark: val.row.remark,
        roleId: val.row.roleId,
      };
      Api.copyRole(params).then((res) => {
        if (res.code === "200") {
          this.$message({
            type: "success",
            message: "复制成功",
          });
          this.getRoleList();
        }
      });
    },
    handleAddRole() {
      this.addRoleDialogShow = true;
      this.dialogTitle = "新增角色";
      this.roleData = {};
    },
    handleDeleteRole() {
      if (this.selectRows.length == 0) {
        this.$message({
          type: "warning",
          message: "请选择删除的数据",
        });
      } else {
        let roleIdList = [];
        this.selectRows.forEach((item) => {
          roleIdList.push(item.roleId);
        });

        let params = {
          roleIdList: roleIdList,
        };

        Api.deleteRole(params).then((res) => {
          this.$confirm(res.data, "提示", {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            type: "warning",
          })
            .then(() => {
              params.flag = "confirm";
              Api.deleteRole(params).then((res) => {
                if (res.code == "200") {
                  this.$message({
                    type: "success",
                    message: "删除成功",
                  });
                  this.getRoleList();
                }
              });
            })
            .catch(() => {
              this.$message({
                type: "info",
                message: "已取消删除",
              });
            });
        });
      }
    },
    handleAssignAuth() {
      if (this.selectRows.length == 1) {
        this.$router.push({
          path: "/assignFunctionAuth",
          query: {
            roleName: this.selectRows[0].roleName,
            roleId: this.selectRows[0].roleId,
          },
        });
      } else {
        this.$message({
          type: "warning",
          message: "请选择一条数据",
        });
      }
    },
    closeAddRole() {
      this.addRoleDialogShow = false;
      this.getRoleList();
    },
    closeCheckRole() {
      this.checkRoleDialogShow = false;
    },
    getRoleList() {
      let params = {
        roleName: this.query.roleName,
        pageSize: this.productTagPage.pageSize,
        pageStart: this.productTagPage.currentPage,
      };

      Api.queryRoleList(params).then((res) => {
        this.tableData = res.data.list;
        this.productTagPage.pageTotal = res.data.total;
      });
    },
  },
};
</script>

<style scoped></style>
